module.exports = __webpack_public_path__ + "static/media/inktoberScarf.8c79d4a7.gif";